import { AngularFireAuth } from 'angularfire2/auth';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { Observable } from 'rxjs/Observable';
import { FirebaseApp } from 'angularfire2';
import { MatSnackBar } from '@angular/material';

import { MatDialog } from '@angular/material';

@Injectable()
export class AuthService {

  user$: Observable<firebase.User>;

  constructor(private afAuth: AngularFireAuth, public dialog: MatDialog) {
    this.user$ = afAuth.authState;
  }

  getUserObservable() {
    return this.user$;
  }

  getCurrentUser() {
    return this.afAuth.auth.currentUser;
  }

  loginWithEmailAndPassword(email, password) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }

  loginWithGoogle() {
    return this.afAuth.auth.signInWithRedirect(new firebase.auth.GoogleAuthProvider());
  }

  loginWithFacebook() {
    return this.afAuth.auth.signInWithRedirect(new firebase.auth.FacebookAuthProvider());
  }

  loginWithTwitter() {
    return this.afAuth.auth.signInWithRedirect(new firebase.auth.TwitterAuthProvider());
  }

  resetPassword(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  logOut() {
    this.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/services/auth.service.ts